<template>
    <div class="form-row" v-if="clients">
        <div class="form-group col-md-4">
            <label for="inputClient">Client</label>
            <select
                id="inputClient"
                name="client_id"
                v-model="selectedClient"
                class="form-control"
                @change="onClientChange"
            >
                <option value="">Pick a client</option>
                <option
                    v-for="client in clients"
                    :value="client.id"
                    :key="client.id"
                >
                    {{ client.name }}
                </option>
            </select>
        </div>
        <div class="form-group col-md-4">
            <label for="inputManufacturer">Manufacturer</label>
            <select
                id="inputManufacturer"
                name="manufacturer_id"
                v-model="selectedManufacturer"
                class="form-control"
                :disabled="!selectedClient"
                @change="emitManufacturerChange"
            >
                <option value="" v-if="!selectedClient">
                    First pick a client
                </option>
                <option value="">Pick a manufacturer</option>
                <option
                    v-for="manufacturer in manufacturers"
                    :value="manufacturer.id"
                    :key="manufacturer.id"
                >
                    {{ manufacturer.name }}
                </option>
            </select>
        </div>
        <div class="form-group col col-md-4">
            <label for="report_template_id">Template</label>
            <select
                required
                id="report_template_id"
                name="report_template_id"
                class="form-control"
                v-model="selectedTemplate"
                :disabled="!selectedClient"
                @change="emitTemplateChange"
            >
                <option value="" v-if="!selectedClient">
                    First pick a client
                </option>
                <option value="">Pick a template</option>
                <option
                    v-for="template in templates"
                    :value="template.id"
                    :key="template.id"
                >
                    {{ template.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TemplateSelect",
  props: {
    initialClientId: {
      type: [String, Number],
      default: null
    },
    initialManufacturerId: {
      type: [String, Number],
      default: null
    },
    initialTemplateId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      clients: null,
      selectedClient: this.initialClientId,
      selectedManufacturer: this.initialManufacturerId,
      selectedTemplate: this.initialTemplateId
    };
  },
  computed: {
    templates() {
      return this.selectedClient && this.clients
        ? this.clients.find(c => c.id === parseInt(this.selectedClient))
            .templates
        : [];
    },
    manufacturers() {
      return this.selectedClient && this.clients
        ? this.clients.find(c => c.id === parseInt(this.selectedClient))
            .manufacturers
        : [];
    }
  },
  mounted() {
    this.fetchData();
    this.emitInitialValues();
  },
  methods: {
    fetchData() {
      if (this.initialClientId) {
        axios
          .get(route("api.clients.show", this.initialClientId))
          .then(response => {
            this.clients = [response.data.data];
          })
          .catch(error => {});
      } else {
        axios
          .get(route("api.clients.list"))
          .then(response => {
            this.clients = response.data.data;
          })
          .catch(error => {});
      }
    },
    onClientChange() {
      this.unsetSelectedOptions();
      this.emitClientChange();
    },
    emitClientChange() {
      this.$emit("update:client-id", this.selectedClient);
    },
    emitManufacturerChange() {
      this.$emit("update:manufacturer-id", this.selectedManufacturer);
    },
    emitTemplateChange() {
      this.$emit("update:template-id", this.selectedTemplate);
    },
    unsetSelectedOptions() {
      this.selectedManufacturer = "";
      this.selectedTemplate = "";
      this.emitManufacturerChange();
      this.emitTemplateChange();
    },
    emitInitialValues() {
      this.emitClientChange();
      this.emitManufacturerChange();
      this.emitTemplateChange();
    }
  }
};
</script>
